module.exports = __webpack_public_path__ + "assets/img/G3.947f2102.png";